import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './chung/nen.css';

const goc = document.getElementById('goc');
if (!goc) throw new Error('Khong tim thay #goc trong index.html');

createRoot(goc).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
